module.exports = __webpack_public_path__ + "public/images/about-2.c7d1c1fc8cf8faebd4ec8fd6d5a8e483.png";